module.exports = __webpack_public_path__ + "img/qxgl.bdbb7f7f.png";